import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import AppBar from '@material-ui/core/AppBar'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import NumComponent from './NumComponent'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { getPaymentIcon } from 'utils/iconMatcher'
// import SwipeableViews from 'react-swipeable-views'

const styles = theme => ({
  root: {
    borderRadius: '5px',
    flexGrow: 1,
    width: '100%',
    marginTop: theme.spacing.unit * 2,
    backgroundColor: theme.palette.grey['100']
  },
  tab: {
    minWidth: '100px'
  },
  appBar: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  container: {
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  rootTabs: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  topGrid: {
    paddingTop: '0 !important'
  },
  scrollContainer: {
    overflow: 'scroll',
    width: 'calc(100%)',
    height: 'calc(100% - 64px)'
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})

class NumPadComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    addPayment: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    paymentTypes: PropTypes.array.isRequired,
    defaultPayment: PropTypes.string,
    credEnabled: PropTypes.bool,
    total: PropTypes.number,
    disabled: PropTypes.bool,
    values: PropTypes.array
  }

  static defaultProps = {
    total: 0,
    credEnabled: false,
    defaultPayment: 'CB',
    disabled: false,
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, '.00', 0, '<']
  }

  state = {
    tabValue: 0,
    value: '0.00',
    type: ''
  }
  componentWillMount() {
    this.setState({ type: this.props.defaultPayment })
  }
  handleTabsChange = (event, value) => {
    this.setState({
      type: value
    })
  }
  handleClick = (value, type) => {
    if (value === '<') {
      this.setState({ value: '0.00' })
      this.props.onClear()
    } else if (value === '.00') {
      let newValue = this.state.value.replace('.', '') + '00'
      newValue =
        newValue.slice(0, newValue.length - 2) +
        '.' +
        newValue.slice(newValue.length - 2)
      this.setState({ value: newValue.replace(/^0+(?=\d)/, '') })
    } else {
      let newValue = this.state.value.replace('.', '') + value
      newValue =
        newValue.slice(0, newValue.length - 2) +
        '.' +
        newValue.slice(newValue.length - 2)
      this.setState({ value: newValue.replace(/^0+(?=\d)/, '') })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.total !== this.props.total) {
      this.setState({
        value: nextProps < 0 ? Number(0).toFixed(2) : nextProps.total.toFixed(2)
      })
    }
  }
  handleAddClick = e => {
    this.props.addPayment(Number(this.state.value), this.state.type)
    this.setState({
      value: '0.00',
      type: this.props.defaultPayment
    })
  }

  render() {
    const { classes, paymentTypes, credEnabled } = this.props
    const { type } = this.state
    return (
      <Paper className={classes.root} elevation={3}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="center"
          spacing={40}>
          <Grid className={classes.topGrid} item xs={12}>
            <AppBar elevation={1} className={classes.appBar} position="static">
              <Tabs
                className={classes.rootTabs}
                value={type}
                onChange={this.handleTabsChange}
                fullWidth
                indicatorColor="secondary">
                {paymentTypes.map((p, i) => {
                  if (p.payment_type === 'CRED' && !credEnabled) return null
                  const icon = getPaymentIcon(p.payment_type)
                  return (
                    <Tab
                      classes={{ root: classes.tab }}
                      key={p.key}
                      icon={icon}
                      value={p.payment_type}
                      label={p.payment_type}
                    />
                  )
                })}
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={8}>
            <Paper elevation={3} style={{ height: 42 }}>
              <Grid container alignItems="center" justify="center">
                <Grid item>
                  <Typography variant="title" gutterBottom>
                    {this.state.value}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid
            item
            xs={11}
            container
            direction="row"
            alignItems="flex-start"
            justify="center"
            spacing={40}>
            {this.props.values.map((value, index) => {
              return (
                <Grid key={index} item xs={4}>
                  <NumComponent
                    disabled={this.props.disabled}
                    onClick={this.handleClick}
                    value={value}
                  />
                </Grid>
              )
            })}
          </Grid>
          <Grid item xs={11}>
            <Button
              fullWidth
              size="large"
              variant="raised"
              color="primary"
              disabled={this.state.value === '0.00'}
              onClick={this.handleAddClick}>
              Ajouter
            </Button>
          </Grid>
        </Grid>
      </Paper>
    )
  }
}
export default withStyles(styles)(NumPadComponent)



// WEBPACK FOOTER //
// ./src/components/numPad/NumPadComponent.js